import { createStore, applyMiddleware, compose } from 'redux'
import { createBrowserHistory } from 'history'
import createSagaMiddleware from 'redux-saga'
import rootSaga from './sagas'
import reducers from './reducers'
import thunk from 'redux-thunk'

// import loader from './reducers/loader'
// import error, * as errorSelector from './reducers/errorReducer'
// import { connectRouter } from 'connected-react-router'
// import session from './reducers/auth/session'

let composeEnhancers = compose
if (process.env.NODE_ENV !== 'production') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeEnhancers
}
export const history = createBrowserHistory()

const sagaMiddleware = createSagaMiddleware()
const middlewares = [thunk, sagaMiddleware]

const store = createStore(
  reducers(history),
  composeEnhancers(
    applyMiddleware(...middlewares)
  )
)

sagaMiddleware.run(rootSaga)

export default store

// export const selectAllErrorsMapped = state => errorSelector.selectAllErrorsMapped(state.error);
